import { render, staticRenderFns } from "./ButtonSpinner.vue?vue&type=template&id=713563ca"
import script from "./ButtonSpinner.vue?vue&type=script&lang=ts"
export * from "./ButtonSpinner.vue?vue&type=script&lang=ts"
import style0 from "./ButtonSpinner.vue?vue&type=style&index=0&id=713563ca&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports